import { useStaticQuery, graphql } from "gatsby"

export const useMenuData = () => {
  const MenuData = useStaticQuery(
    graphql`
      query MenuMetaData {
        wpPage(id: { eq: "cG9zdDoxNDA1NDE=" }) {
          id
          title
          MenuPageFields {
            menuItemsList {
              menuItemText
              menuHasLink
              menuItemLink {
                ... on WpPage {
                  uri
                }
              }
              menuSubMenuItems
              menuSubMenuList {
                menuSubMenuTitle
                subMenuTitleHasLink
                menuSubMenuLink {
                  ... on WpPage {
                    uri
                  }
                }
                menuSubSubMenuList {
                  menuSubSubMenuTitle
                  menuSubSubMenuLink {
                    ... on WpPage {
                      uri
                    }
                  }
                }
              }
            }
            resMenuItemsList {
              resMenuItemText
              resMenuHasLink
              resMenuItemLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              resMenuSubMenuItems
              resMenuSubMenuList {
                resSubMenuImage {
                  mediaItemUrl
                }
                resMenuSubMenuTitle
                resSubMenuContent
                resSubMenuLinkText
                resMenuSubMenuLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return MenuData
}
